module.exports = __webpack_public_path__ + "img/Truppführer_I.8295e107.svg";